import { Button, Center, Flex, Select, Text } from "@mantine/core";
import { modals } from "@mantine/modals";

import SRD_Form from "components/Form";
import { userState } from "pages/Login/atom/userState";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { getPathname } from "utils/getPathname";
import {
  deleteLibraryInfo,
  getLibrary,
  updateLibraryInfo,
} from "../apis/adminLibraryApis";

function LibraryEditForm() {
  const [user, setUser] = useRecoilState(userState);
  const level = Number(user?.fn_level);
  const adminLevel = [0].includes(level);
  const groupId = user.fn_group_id;
  const pk_no = getPathname();
  const navigate = useNavigate();
//  const [selectedUsedScope, setSelectedUsedScope] = useState();
  const [defaultValues, setDefaultValues] = useState();

  const location = useLocation();
  let backPage = 1;
  if (location.state) {
    backPage = location.state.pg;
  }

  const backToList = () => {
    const params = new URLSearchParams({page: String(backPage)});
    navigate(`/admin/library?${params.toString()}`, {replace: true});
  };

  useEffect(() => {
    getLibrary(pk_no).then((res) => {
      let used_scope = "1";
      if (res.menu !== "L"){
        used_scope = "2";
      }
      res["used_scope"] = used_scope;
      setDefaultValues(res);
    });
  }, [pk_no]);

  const usedScopeOptions = [
    { value: "1", label: "전체" },
    { value: "2", label: "그룹 내부" },
  ];

  const SelectUsedScope = (props) => {
    const { field, name, defaultValue } = props;
 //   setSelectedUsedScope(field.value);
    return (
      <Select
        label={name}
        data={usedScopeOptions}
        value={field.value}
   //     defaultValue={defaultValue}
        {...field}
      />
    );
  };

  const fields = [
    {
      key: "title",
      name: "이름",
      type: "text",
    },
    {
      key: "file",
      name: "이미지",
      type: "file",
    },
    {
      key: "used_scope",
      name: "공개 범위",
      type: "etc",
      component: SelectUsedScope,
 //     defaultValue: selectedUsedScope,
    },
  ];

  const onSubmit = (e) => {
    modals.openConfirmModal({
      title: "수정",
      children: <Center>수정 하시겠습니까?</Center>,
   //   centered: true,
      zIndex: 2000,
      labels: { confirm: "수정", cancel: "취소" },
      onConfirm: () => {
        let grpId = defaultValues?.reg_user_group;
        updateLibraryInfo(e,grpId);
        backToList();
      },
    });
  };
  const onDelete = () => {
    modals.openConfirmModal({
      title: "삭제",
   //   centered: true,
      zIndex: 2000,
      children: (
        <Center>
          <Text>정말 삭제하시겠습니까? (삭제 후 복구불가)</Text>
        </Center>
      ),
      labels: { confirm: "삭제", cancel: "취소" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        deleteLibraryInfo(pk_no);
        navigate("/admin/library");
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Flex
          style={{
            width: "100%",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <Button type="submit"
                  disabled={ !adminLevel && (user?.user_id !== defaultValues?.reg_user)}
          >
            수정
          </Button>
          <Button color="red" onClick={() => onDelete()}
                  disabled={!adminLevel && (user?.user_id !== defaultValues?.reg_user)}
          >
            삭제
          </Button>
          <Button type="button" onClick={() => navigate("/admin/library")}>
            취소
          </Button>
        </Flex>
      </Center>
    );
  };

  return ( 
      <SRD_Form
        fields={fields}
        onSubmit={onSubmit}
        submitButton={<SubmitButton />}
        defaultValues={defaultValues}
      />
  );
}

export default LibraryEditForm;
